import { render } from "./HomeBaseUsers.vue?vue&type=template&id=39f6f142"
import script from "./HomeBaseUsers.vue?vue&type=script&lang=js"
export * from "./HomeBaseUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__